<div *ngIf="{ value: showPayableSelections$ | async } as showPayableSelections" class="invoice-card" (click)="openSnackBar()">
  <div class="grid-row grid-row--aic grid-row--smg invoice-card__header">
    <div class="grid-col grid-col--auto">
      <div class="form-checkbox invoice-card__checkbox">
        <input
          [checked]="showPayableSelections.value && invoiceTableDataObject.checked"
          [disabled]="invoiceTableDataObject.disabled"
          [ngClass]="{'checkbox_disabled' : invoiceTableDataObject.disabled}"
          type="checkbox"
          name="checkbox"
          class="form-checkbox__input"
          (click)="toggleCard()"
          data-cy="select-invoice"
        >
        <span class="form-checkbox__icon"></span>
      </div>
    </div>

    <div class="grid-col grid-col--auto invoice-card-label-container">
      <ng-container *ngIf="!everyInvoiceBelongsToSameEntity">
        <div class="tc--light invoice-card__label">Business Entity</div>
      </ng-container>
      <div class="tc--light invoice-card__label">Invoice #</div>
    </div>

    <div class="grid-col invoice-card-label-container">
      <ng-container *ngIf="!everyInvoiceBelongsToSameEntity">
        <div class="p tc--primary">{{invoiceTableDataObject?.entityName}}</div>
      </ng-container>
      <div class="p tc--primary">{{ invoiceTableDataObject.invoiceNumber }}</div>
    </div>

    <div class="grid-col grid-col--auto">
      <button [disabled]="invoiceTableDataObject.invoice.invoiceFileId == null" type="button" class="button button--sm invoice-card__more" [matMenuTriggerFor]="menu">
        <svg width="16px" height="16px" viewBox="0 0 16 16" class="button__icon">
          <circle fill="currentColor" cx="8" cy="8" r="2"></circle>
          <circle fill="currentColor" cx="2" cy="8" r="2"></circle>
          <circle fill="currentColor" cx="14" cy="8" r="2"></circle>
        </svg>
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        <button (click)="invoicePdfService.previewInvoiceAsPDF(invoiceTableDataObject.invoice.arTran.id)" mat-menu-item data-cy="preview-invoice">Preview</button>
        <button (click)="invoicePdfService.exportInvoiceAsPDF(invoiceTableDataObject.invoice.arTran.id, invoiceTableDataObject.invoice.invoiceNumber)" mat-menu-item data-cy="export-invoice">Export</button>
      </mat-menu>
    </div>
  </div>

  <div class="mt--075 h2">
    {{ invoiceTableDataObject.amountRemaining | currency : invoiceTableDataObject.currency?.code }}
  </div>

  <ng-container *ngIf="!everyInvoiceBelongsToSameEntity">
    <div class="p tc--darkest invoice-card__client">{{invoiceTableDataObject?.clientName}}</div>
    <div class="p tc--darkest invoice-card__description">{{invoiceTableDataObject?.invoice?.description}}</div>
  </ng-container>

  <div class="mt--075 invoice-card__hr"></div>

  <div class="mt--075 grid-row grid-row--aic">
    <div class="grid-col grid-col--auto">
      <div *ngIf="invoiceTableDataObject.invoice.arTran.amount > invoiceTableDataObject.invoice.arTran.allocated" class="p fw--300 tc--darkest">Due {{invoiceTableDataObject.dueDateDisplay}}</div>

      <!--This was commented out since it used latestPaymentDate which was removed from the invoice-ui object.  This was left here for styling reference in the future.  If an invocie card needs to be created
      for the paid table, this will need to be reworked to use the payemnt-ui, which has the transaction date (which replaces the latestPaidDate).-->
      <!--      <div *ngIf="invoiceTableDataObject.invoice.arTran.amount === invoiceTableDataObject.invoice.arTran.allocated" class="p fw&#45;&#45;300 tc&#45;&#45;success">Paid {{invoiceTableDataObject.latestPaymentDate | date: 'MM/dd/yy'}}</div>-->
    </div>

    <div *ngIf="invoiceTableDataObject.invoice.arTran.amount > invoiceTableDataObject.invoice.arTran.allocated" class="grid-col">
      <div *ngIf="invoiceTableDataObject.overdue">
        <div class="badge badge--error">
          <div class="badge__label">Overdue</div>
          <div class="badge__date">{{invoiceTableDataObject.displayStatus}}</div>
        </div>
      </div>
      <div *ngIf="!invoiceTableDataObject.overdue">
        <div class="badge badge--warning">
          <div class="badge__label">Due</div>
          <div class="badge__date">{{invoiceTableDataObject.displayStatus}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
